
import React, { memo } from "react";
import { Movie } from "@/types/movie";
import MovieCardContainer from "./MovieCardContainer";
import DirectorSectionHeader from "./DirectorSectionHeader";

interface DirectorSectionItemProps {
  directorName: string;
  movies: Movie[];
  currentTab: string;
  viewMode: "grid" | "list";
  onOpenMovieDetails?: (tmdbId: number) => void;
}

// Using memo to prevent unnecessary re-renders
const DirectorSectionItem = memo<DirectorSectionItemProps>(({ 
  directorName, 
  movies, 
  currentTab,
  viewMode,
  onOpenMovieDetails
}) => {
  return (
    <div 
      className="director-section fade-in mb-5 md:mb-8 lg:mb-10" 
      data-director={directorName}
    >
      <DirectorSectionHeader directorName={directorName} />
      <div className={viewMode === "grid" ? "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4" : "space-y-2"}>
        {movies.map((movie) => (
          <MovieCardContainer 
            key={movie.tmdbId}
            movie={movie}
            currentTab={currentTab}
            viewMode={viewMode}
            onOpenMovieDetails={onOpenMovieDetails}
          />
        ))}
      </div>
    </div>
  );
});

DirectorSectionItem.displayName = "DirectorSectionItem";

export default DirectorSectionItem;
